import { render, staticRenderFns } from "./ManageSettings.vue?vue&type=template&id=16a1ff0e"
import script from "./ManageSettings.vue?vue&type=script&lang=js"
export * from "./ManageSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports